import Cookies from 'universal-cookie'
import decode from 'jwt-decode'
import { CUSTOMER_ID_COOKIE_KEY, AUTH_TOKEN } from '@mindfulchefuk/constants'
import errorHandler from '@mindfulchefuk/utils/errorHandler'

interface Session {
  customer_id: string
  exp: number
}

export const setToken = (authToken: string): void => {
  try {
    const cookies = new Cookies()
    const session = decode(authToken) as Session
    const sessionMultiplier = 1000
    const durationReductionInSeconds = 10

    const jwtExpiryInSeconds = new Date(session.exp * sessionMultiplier)

    jwtExpiryInSeconds.setDate(
      jwtExpiryInSeconds.getDate() - durationReductionInSeconds
    )

    // Set the customer id cookie so our application knows
    // that the current user is authenticated
    cookies.set(CUSTOMER_ID_COOKIE_KEY, session.customer_id, {
      path: '/',
      expires: jwtExpiryInSeconds,
    })

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(AUTH_TOKEN, authToken)
    }
  } catch (err) {
    errorHandler(err)
  }
}
